import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';

export interface IRightMenuService {
  userModalVisibility: boolean;
  openUserModal();
  closeUserModal();
  knowledgeBlockVisibility: boolean;
  openKnowledgeBlockModal();
  closeKnowledgeBlockModal();
}

class RightMenuServiceImpl implements IRightMenuService {
  @observable public userModalVisibility = false;
  @observable public knowledgeBlockVisibility = false;

  public openUserModal() {
    this.userModalVisibility = true;
  }

  public closeUserModal() {
    this.userModalVisibility = false;
  }

  public openKnowledgeBlockModal() {
    this.knowledgeBlockVisibility = true;
  }

  public closeKnowledgeBlockModal() {
    this.knowledgeBlockVisibility = false;
  }
}
export const IRightMenuService = DI.createInterface<IRightMenuService>((x) =>
  x.singleton(RightMenuServiceImpl)
);
